import { render, staticRenderFns } from "./MiTarjetaPrepaga.vue?vue&type=template&id=08aad228&"
import script from "./MiTarjetaPrepaga.vue?vue&type=script&lang=js&"
export * from "./MiTarjetaPrepaga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports